module.exports = __WEBPACK_EXTERNAL_MODULE_211__;


//////////////////
// WEBPACK FOOTER
// external "rxjs/add/operator/filter"
// module id = 211
// module chunks = 0